'use strict';
const Router = require('autor');
const pdf    = require('./pdf.js');

class Route extends Router.Route {
  load(resolve) {
    Router.post(document.location.origin + Router.location.pathname + '?partial', {}, (err, req) => {
      document.body.setAttribute('data-path', Router.location.pathname);
      document.querySelector('main').innerHTML = req.responseText;
      window.scrollTo( 0, 0 );
      resolve();
    });
  }

  bootstrap(route) {
    pdf.initPdfViewer();
    document.getElementById('overlay-title').innerHTML = '';
    document.title = 'All Conference — ' + document.querySelector('.pdf-viewer').getAttribute('data-title');
  }
}

module.exports = Route;



// WEBPACK FOOTER //
// ./src/js/document.service.js